"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/shipping/v1/internal_service.proto (package spwn.shipping.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalShippingServiceRequestShippingResponse = exports.InternalShippingServiceRequestShippingRequest = exports.InternalShippingServiceGetAllFulfillmentsByOrderIdsResponse = exports.InternalShippingServiceGetAllFulfillmentsByOrderIdsRequest = exports.InternalShippingServiceGetFulfillmentByOrderIdResponse = exports.InternalShippingServiceGetFulfillmentByOrderIdRequest = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
const internal_common_pb_1 = require("./internal_common_pb");
/**
 * @generated from message spwn.shipping.v1.InternalShippingServiceGetFulfillmentByOrderIdRequest
 */
class InternalShippingServiceGetFulfillmentByOrderIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string order_id = 1;
         */
        this.orderId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalShippingServiceGetFulfillmentByOrderIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalShippingServiceGetFulfillmentByOrderIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalShippingServiceGetFulfillmentByOrderIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalShippingServiceGetFulfillmentByOrderIdRequest, a, b);
    }
}
exports.InternalShippingServiceGetFulfillmentByOrderIdRequest = InternalShippingServiceGetFulfillmentByOrderIdRequest;
InternalShippingServiceGetFulfillmentByOrderIdRequest.runtime = protobuf_1.proto3;
InternalShippingServiceGetFulfillmentByOrderIdRequest.typeName = "spwn.shipping.v1.InternalShippingServiceGetFulfillmentByOrderIdRequest";
InternalShippingServiceGetFulfillmentByOrderIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.shipping.v1.InternalShippingServiceGetFulfillmentByOrderIdResponse
 */
class InternalShippingServiceGetFulfillmentByOrderIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalShippingServiceGetFulfillmentByOrderIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalShippingServiceGetFulfillmentByOrderIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalShippingServiceGetFulfillmentByOrderIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalShippingServiceGetFulfillmentByOrderIdResponse, a, b);
    }
}
exports.InternalShippingServiceGetFulfillmentByOrderIdResponse = InternalShippingServiceGetFulfillmentByOrderIdResponse;
InternalShippingServiceGetFulfillmentByOrderIdResponse.runtime = protobuf_1.proto3;
InternalShippingServiceGetFulfillmentByOrderIdResponse.typeName = "spwn.shipping.v1.InternalShippingServiceGetFulfillmentByOrderIdResponse";
InternalShippingServiceGetFulfillmentByOrderIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "fulfillment", kind: "message", T: internal_common_pb_1.InternalFulfillment },
]);
/**
 * @generated from message spwn.shipping.v1.InternalShippingServiceGetAllFulfillmentsByOrderIdsRequest
 */
class InternalShippingServiceGetAllFulfillmentsByOrderIdsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated string order_ids = 1;
         */
        this.orderIds = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalShippingServiceGetAllFulfillmentsByOrderIdsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalShippingServiceGetAllFulfillmentsByOrderIdsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalShippingServiceGetAllFulfillmentsByOrderIdsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalShippingServiceGetAllFulfillmentsByOrderIdsRequest, a, b);
    }
}
exports.InternalShippingServiceGetAllFulfillmentsByOrderIdsRequest = InternalShippingServiceGetAllFulfillmentsByOrderIdsRequest;
InternalShippingServiceGetAllFulfillmentsByOrderIdsRequest.runtime = protobuf_1.proto3;
InternalShippingServiceGetAllFulfillmentsByOrderIdsRequest.typeName = "spwn.shipping.v1.InternalShippingServiceGetAllFulfillmentsByOrderIdsRequest";
InternalShippingServiceGetAllFulfillmentsByOrderIdsRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "order_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
]);
/**
 * @generated from message spwn.shipping.v1.InternalShippingServiceGetAllFulfillmentsByOrderIdsResponse
 */
class InternalShippingServiceGetAllFulfillmentsByOrderIdsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.shipping.v1.InternalFulfillment fulfillments = 1;
         */
        this.fulfillments = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalShippingServiceGetAllFulfillmentsByOrderIdsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalShippingServiceGetAllFulfillmentsByOrderIdsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalShippingServiceGetAllFulfillmentsByOrderIdsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalShippingServiceGetAllFulfillmentsByOrderIdsResponse, a, b);
    }
}
exports.InternalShippingServiceGetAllFulfillmentsByOrderIdsResponse = InternalShippingServiceGetAllFulfillmentsByOrderIdsResponse;
InternalShippingServiceGetAllFulfillmentsByOrderIdsResponse.runtime = protobuf_1.proto3;
InternalShippingServiceGetAllFulfillmentsByOrderIdsResponse.typeName = "spwn.shipping.v1.InternalShippingServiceGetAllFulfillmentsByOrderIdsResponse";
InternalShippingServiceGetAllFulfillmentsByOrderIdsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "fulfillments", kind: "message", T: internal_common_pb_1.InternalFulfillment, repeated: true },
]);
/**
 * @generated from message spwn.shipping.v1.InternalShippingServiceRequestShippingRequest
 */
class InternalShippingServiceRequestShippingRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 注文ID
         *
         * @generated from field: string order_id = 1;
         */
        this.orderId = "";
        /**
         * 発送する住所
         *
         * @generated from field: string address_id = 2;
         */
        this.addressId = "";
        /**
         * ユーザーID
         *
         * @generated from field: string user_id = 3;
         */
        this.userId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalShippingServiceRequestShippingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalShippingServiceRequestShippingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalShippingServiceRequestShippingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalShippingServiceRequestShippingRequest, a, b);
    }
}
exports.InternalShippingServiceRequestShippingRequest = InternalShippingServiceRequestShippingRequest;
InternalShippingServiceRequestShippingRequest.runtime = protobuf_1.proto3;
InternalShippingServiceRequestShippingRequest.typeName = "spwn.shipping.v1.InternalShippingServiceRequestShippingRequest";
InternalShippingServiceRequestShippingRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "address_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.shipping.v1.InternalShippingServiceRequestShippingResponse
 */
class InternalShippingServiceRequestShippingResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 発送リクエストID
         *
         * @generated from field: string fulfillment_request_id = 1;
         */
        this.fulfillmentRequestId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalShippingServiceRequestShippingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalShippingServiceRequestShippingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalShippingServiceRequestShippingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalShippingServiceRequestShippingResponse, a, b);
    }
}
exports.InternalShippingServiceRequestShippingResponse = InternalShippingServiceRequestShippingResponse;
InternalShippingServiceRequestShippingResponse.runtime = protobuf_1.proto3;
InternalShippingServiceRequestShippingResponse.typeName = "spwn.shipping.v1.InternalShippingServiceRequestShippingResponse";
InternalShippingServiceRequestShippingResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "fulfillment_request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
//# sourceMappingURL=internal_service_pb.js.map